import { createFileRoute } from '@tanstack/react-router';

import { SaleDetailPage, saleLotsQueryOptions, saleQueryOptions } from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/sales/$saleId')({
  loader: async ({ context, params }) => {
    const [sale] = await Promise.all([
      context.queryClient.query({
        ...saleQueryOptions(params.storeId, params.saleId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...saleLotsQueryOptions(params.storeId, params.saleId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: sale.title };
  },
  component: SaleDetailPage,
});
